// extracted by css-extract-rspack-plugin
export default {"image":"_23a480a3","imageContainer":"_20eda0a4","halfWidth":"_d4b299c1"};